import {
  closeModalSafely as closeModalSafelyBase,
  handleSubmit as handleSubmitBase,
} from '../modals.service';

export const closeModalSafely = closeModalSafelyBase;

export const handleSubmit = (values, object) =>
  handleSubmitBase(
    object.type === 'FoodItem'
      ? 'items/food'
      : object.type === 'InfoMenuEntry'
      ? 'menu-entries/info'
      : object.type === 'ItemCategory' && 'item-categories',
    'editMenuEntryCategorySuccess',
    'editMenuEntryCategoryError',
    null,
    null,
    null,
    [],
    values,
    { id: object.id },
    true,
    () => undefined,
    () => undefined,
    () => undefined,
    () => undefined,
  );
